import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { APP_CONFIG } from '@kros-sk/core/app-config';
import { AppInsightsBaseService } from '@kros-sk/core/application-insights';
import { createHttpRetryErrorForLog, httpRetryAndLog, HttpRetryResult } from '@kros-sk/core/http-retry';
import { IGNORE_REQUEST_ERROR_CODES } from '@kros-sk/core/ignore-request-errors';

import { FeatureFlags, IFeatureFlagsService } from '../types/feature-flags.types';

const featureFlagsUrlPostfix = '/FeatureFlags';

@Injectable()
export class FeatureFlagsApiService implements IFeatureFlagsService {
  private readonly appInsightsService = inject(AppInsightsBaseService);
  private readonly config = inject(APP_CONFIG);
  private readonly http = inject(HttpClient);

  loadFeatureFlags(): Observable<FeatureFlags> {
    const serverUrl = `${this.config.gatewayApiUrl}${featureFlagsUrlPostfix}`;
    return this.http.get<FeatureFlags>(serverUrl, {
      context: new HttpContext().set(IGNORE_REQUEST_ERROR_CODES, ['401', '504']),
    }).pipe(
      httpRetryAndLog({
        retryOnStatus: /504/,
        retryDelays: [300, 600],
        loggerFn: this.logHttpRetryException('loadFeatureFlags', 'GET'),
      })
    );
  }

  private logHttpRetryException = (apiMethod: string, httpRequestMethod: string) => {
    return (log: HttpRetryResult): void => {
      const handler = 'FeatureFlagsApiService';
      this.appInsightsService.trackException(
        createHttpRetryErrorForLog(handler, apiMethod, httpRequestMethod),
        handler,
        log
      );
    };
  };
}
